import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp, faPlus } from '@fortawesome/free-solid-svg-icons'

interface Props {
    currentPosition: number
    previousPosition: number
}

const PositionIcon: React.FC<Props> = (props) => {
    const getPositionIcon = (currentPos: number, prevPos: number) => {
        if (prevPos === null) {
            return <FontAwesomeIcon icon={faPlus} color="#0074d9" />
        }
        if (currentPos < prevPos) {
            return <FontAwesomeIcon icon={faChevronUp} color="#25aa34" />
        }
        if (currentPos > prevPos) {
            return <FontAwesomeIcon icon={faChevronDown} color="#ff4136" />
        }
        return
    }

    return <>{getPositionIcon(props.currentPosition, props.previousPosition)}</>
}
export default PositionIcon
